export const environment = {
    //apiUrl : "https://localhost:7226/api/v2",
    // apiUrl : "https://true-mart-api.runasp.net/api/v2",
    

    
    api:"https://truehosting.egtrue.net/api",
    //api:"https://localhost:7125/api",
    photosUrl : "https://true-mart-api.runasp.net",
    logoUrl:"assets/uploads/images/logo.png",
    customer:""

};
